import { Users, Search, ChevronUp, ChevronDown, X, Send, User, Calendar, Phone, Star, ShieldCheck, Infinity, Hospital, MapPin, Printer, MapPinned, UserRoundCog, CircleHelp, CircleCheck, Loader, Info } from "lucide-react";
import DatePicker from "react-datepicker";
import React, { useCallback, useEffect, useState } from "react";
import Select from "react-select";
import DataTablePagination from "../DataTablePagination";
import Filter from "../Filter";
import Spacing from "../Spacing";
import { convertDateWithSlash, datePickerFormat, debounce, exchangeDate, generatePatientTableData, getPractice, getSpeciality, notify, usPhoneFormat } from "../../helpers";
import BackBtn from "../Button/BackBtn";
import { fetchPatients } from "../../services/patient";
import ReferralPatientDataTable from "../DataTable/ReferralPatientDataTable";
import { createAndUpdateRefrerral, fetchAllSpecialist, fetchInternalSpecialist, getAllUSStates } from "../../services/easyReferral";
import ReferralPracticeDataTable from "../DataTable/ReferralPracticeDataTable";
import Badge from "../UI/Badge";
import { useDocumentTitle } from "../../hooks/customDocumentTitleHook";
import InsuranceViewModal from "../Modal/InsuranceViewModal";
import InviteSpecialistModal from "../Modal/InviteSpecialistModal";
import { useLocation } from "react-router-dom";
import FilterSummary from "../UI/FilterSummary";
import SaveFilter from "../Filter/SaveFilter";
import { fetchFilterData } from "../../services/saveFilter";
import FilterSaveConfirmationModal from "../Modal/FilterSaveConfirmationModal";
import { Config } from "../../Config";


export default function ReferNewPatient({selectedPracticeChange,fetchChangePracticeData,changePracticeSpeciality}) {
  let location_id = getPractice("location_id");
  let account_id = getPractice("account_id");
  let user_id = getPractice("user_id");
  let specialty_id = getSpeciality()?.id || 32;
  if(selectedPracticeChange != null && fetchChangePracticeData && changePracticeSpeciality!=null){
    location_id = selectedPracticeChange?.location_id;
    account_id = selectedPracticeChange?.account_id;
    specialty_id = selectedPracticeChange?.specialities[0]?.id || 32;
  }
  if (changePracticeSpeciality != null) {
    specialty_id = changePracticeSpeciality?.id || 32;
  }

  const [previousScrollPosition, setPreviousScrollPosition] = useState(0);
  const location = useLocation();
  const { state } = location;
  const [activeIndex, setActiveIndex] = useState(0);
  const [submitButtonLoader, setSubmitButtonLoader] = useState(false);
  const [viewInsurances, setViewInsurances] = useState(false);
  const [viewInvitationModal, setViewInvitationModal] = useState(false);
  const [acceptInsuranceData, setAcceptInsuranceData] = useState({});
  const [patientDataLoading, setPatientDataLoading] = useState(true);
  const [patientData, setPatientData] = useState([]);
  const [specialistData, setSpecialistData] = useState([]);
  const [specialistDataLoading, setSpecialistDataLoading] = useState(true);
  const [isFilterCleared, setIsFilterCleared] = useState(false);
  const [showSave, setShowSave] = useState(true);
  const [savePatientConfirmModal, setSavePatientConfirmModal] = useState(false);
  const [filterData, setFilterData] = useState([]);
  const [statesData, setStatesData] = useState([]);
  const defaultPatientFilter = {
    account_id: account_id,
    location_id: location_id,
    page: 1,
    per_page: 10,
    search_term: "",
    first_name: "",
    last_name: "",
    dob: "",
    sex: "",
    mobile_phone: "",
    start_age: "",
    end_age: "",
    insurance_ids: [],
    last_visit: "",
    city: "",
    state: "",
    zip: "",
    patient_type: 1
  };
  const [patientFilter, setPatientFilter] = useState(defaultPatientFilter);
  const [patientFormData, setPatientFormData] = useState(patientFilter);
  const [selectedInsuranceOptions, setSelectedInsuranceOptions] = useState([]);
  const [patientDataCount, setPatientDataCount] = useState({
    totalCount: 0,
    totalPages: 0,
  });
  const defaultSpecialistFilter = {
    account_id: account_id,
    location_id: location_id,
    speciality_id: specialty_id,
    page: 1,
    per_page: 10,
    state: "NY",
    type: "internal",
    search_term: "",
    provider_name: "",
    practice_name: "",
    city: "",
    practice_state: "",
    postal_code: "",
    speciality_ids: []
  };
  const [specialistFilter, setSpecialistFilter] = useState(defaultSpecialistFilter);
  const [specialistFormData, setSpecialistFormData] = useState(specialistFilter);
  const [specialistDataCount, setSpecialistDataCount] = useState({
    totalCount: 0,
    totalPages: 0,
  });

  const [checkPatientData, setCheckPatientData] = useState(null);
  const [checkPracticeData, setCheckPracticeData] = useState(null);
  const [selectMedicalFiles, setSelectMedicalFiles] = useState([]);
  const today = new Date();
  const oneYearLater = new Date(today);
  oneYearLater.setFullYear(today.getFullYear() + 1);
  const defaultReferralData = {
    patient_id: "",
    refer_to_npi: "",
    refer_to_state: "",
    account_id: account_id,
    location_id: location_id,
    refer_from_specialty_id: specialty_id,
    refer_to_specialty_id: null,
    patient_conditon: "Normal",
    dos: convertDateWithSlash(today),
    refer_date: convertDateWithSlash(today),
    refer_end_date: convertDateWithSlash(oneYearLater),
    refer_reason: "",
    active_medication_list: "",
    diagnosis: "",
    attach_medical_summary_files: [],
    refer_auth_code: ""
  };
  const [referPatientData, setReferPatientData] = useState(defaultReferralData);

  const handleClearFilters = () => {
    setIsFilterCleared(true);
  };

  const handleResetFilterStatus = () => {
    setIsFilterCleared(false);
  };

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    if (state) {
      setCheckPatientData(state?.data);;
      toggleAccordion(1);
      setReferPatientData({
        ...referPatientData,
        patient_id: state?.data?.id,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  useEffect(() => {
    getAllStates();
  }, []);

  const getAllStates = async () => {
    const response = await getAllUSStates();
    if (response) {
      setStatesData(response);
      const allStatusOptions = response?.map((option) => ({
        value: option?.sort_name,
        label: option?.name,
      }));
      setStatesData(allStatusOptions);
    }
  }

  useEffect(() => {
    setPatientFilter({
      ...patientFilter,
      location_id: location_id,
      account_id: account_id
    });
    setPatientDataLoading(true);
    setSpecialistFilter({
      ...specialistFilter,
      location_id: location_id,
      account_id: account_id,
      speciality_id: specialty_id,
      refer_from_specialty_id: specialty_id,
    });
    setSpecialistDataLoading(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location_id, account_id, specialty_id]);

  useEffect(() => {
    loadPatientData(patientFilter);
  }, [patientFilter]);

  const loadPatientData = async (getFilter) => {
    setPatientFilter(getFilter);
    try {
      const response = await fetchPatients(getFilter);
      if(response) {
        if (response?.detail) {
          notify('error', response?.detail);
        } else { 
          const generateData = generatePatientTableData(response.data.results);
          setPatientData(generateData);
          setPatientDataCount({
            totalCount: response.data.count,
            totalPages: response.data.total_pages,
          });
        }
      }
    } catch (error) {
      // console.log("🚀 ~ loadPatientData ~ error:", error);
    } finally {
      setPatientDataLoading(false);
    }
  };

  const handleChangePatientSearchTerm = (event) => {
    setPatientFilter({ ...patientFilter, search_term: event.target.value });
    setPatientDataLoading(true);
  };

  const handlePatientPageChange = (newPage) => {
    setPatientFilter({ ...patientFilter, page: newPage });
    setPatientDataLoading(true);
  };

  const handleChangePatientRowsPerPage = (value) => {
    setPatientFilter({
      ...patientFilter,
      page: 1,
      per_page: value,
    });
    setPatientDataLoading(true);
  };

  // useEffect(() => {
  //   loadSpecialistData(specialistFilter);
  // }, [specialistFilter]);
  
  useEffect(() => {
    loadInternalSpecialistData(specialistFilter);
  }, [specialistFilter]);

  // const loadSpecialistData = async (getFilter) => {
  //   setSpecialistFilter(getFilter);
  //   try {
  //     const response = await fetchAllSpecialist(getFilter);
  //     if (response) {
  //       if(!response?.detail) {
  //         const generateData = response.data.results;
  //         setSpecialistData(generateData);
  //         setSpecialistDataCount({
  //           totalCount: response.data.count,
  //           totalPages: response.data.total_pages,
  //         });
  //         setSpecialistDataLoading(false);
  //       }
  //     }
  //   } catch (error) {}
  // };


  const loadInternalSpecialistData = async (getFilter) => {
    setSpecialistFilter(getFilter);
    try {
      const response = await fetchInternalSpecialist(getFilter);
      if(response) {
        if (response?.detail) {
          notify('error', response?.detail);
        } else { 
          const generateData = response?.data;
          setSpecialistData(generateData);
          setSpecialistDataCount({
            totalCount: 100,
            totalPages: 1,
          });
        }
      }
    } catch (error) {
      // console.log("🚀 ~ loadInternalSpecialistData ~ error:", error);
    } finally {
      setSpecialistDataLoading(false);
    }
  };



  const debouncedSetSpecialistFilter = useCallback(
    debounce((newFilter) => setSpecialistFilter(newFilter), 300), []
  );

  const handleChangeSpecialistSearchTerm = (event) => {
    const newFilter = { ...specialistFilter, search_term: event.target.value, page: 1 };
    setSpecialistDataLoading(true);
    debouncedSetSpecialistFilter(newFilter);
  };

  const handleSpecialistPageChange = (newPage) => {
    setSpecialistFilter({ ...specialistFilter, page: newPage });
    setSpecialistDataLoading(true);
  };

  const handleChangeSpecialistRowsPerPage = (value) => {
    setSpecialistFilter({
      ...specialistFilter,
      page: 1,
      per_page: value,
    });
    setSpecialistDataLoading(true);
  };

  const handleChangeReferDate = (name, value) => {
    setReferPatientData({
      ...referPatientData,
      [name]: datePickerFormat(value),
    });
  };

  const handleMedicalFileChange = (event) => {
    const files = Array.from(event.target.files);
    const acceptFileSize = Config?.uploadFileSizeLimit * 1024 * 1024;

    const validFiles = files.filter((file) => file.size <= acceptFileSize);
    const invalidFiles = files.filter((file) => file.size > acceptFileSize);

    if (invalidFiles.length > 0) {
      notify("error", `Exceed the size limit of ${Config?.uploadFileSizeLimit}MB`);
    }
    const updatedFiles = [...selectMedicalFiles, ...validFiles];
    setSelectMedicalFiles(updatedFiles);

    setReferPatientData({
      ...referPatientData,
      attach_medical_summary_files: updatedFiles,
    });
  };

  const removeFile = (index) => {
    const newFiles = selectMedicalFiles.filter((_, i) => i !== index);
    setSelectMedicalFiles(newFiles);

    setReferPatientData({
      ...referPatientData,
      attach_medical_summary_files: newFiles,
    });
  };

  const handleReferralChange = (e) => {
    const { name, value } = e.target;
    setReferPatientData({
      ...referPatientData,
      [name]: value
    });
  };

  const handleViewInsurances = (item) => {
    setAcceptInsuranceData(item);
    setViewInsurances(true);
  }

  const handleReferSubmit = async (e) => {
    e.preventDefault();
    setSubmitButtonLoader(true);
    e.target.disabled = true;

    try {
      const response = await createAndUpdateRefrerral(referPatientData);
      if(response){
        if(response?.detail) {
          notify("error", response?.detail);
        } else {
          setPatientFilter(defaultPatientFilter);
          setSpecialistFilter(defaultSpecialistFilter);
          setReferPatientData(defaultReferralData);
          setCheckPatientData(null);
          setCheckPracticeData(null);
          setActiveIndex(0);
          notify("success", response?.data?.message);
        }
      }
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", error?.response?.data?.detail, 0.5);
      }
    } finally {
      setSubmitButtonLoader(false);
    }

    e.target.disabled = false;
  };

  const clearFilterField = (field) => {
    setPatientFilter((prevFilter) => ({
      ...prevFilter,
      [field]: "",  // Clear the specified field in filter state
    }));
    setPatientFormData((prevData) => ({
      ...prevData,
      [field]: "",  // Clear the specified field in patientFormData
    }));
  };

  const loadFilters = async () => {
    const filters = {
      account_id: account_id,
      location_id: location_id,
      user_id: user_id,
      filter_type: "patient-database",
    };

    try {
      const response = await fetchFilterData(filters);
      if (response) {
        if (response?.detail) {
          notify("error", response?.detail);
        } else {
          setFilterData(response?.data);
        }
      }
    } catch (error) {
      // console.log("🚀 ~ loadFilters ~ error:", error);
    }
  };

  useEffect(() => {
    loadFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account_id, location_id]);

  const handelChangeState = (selectedOption) => {
    setSpecialistDataLoading(true);
    setSpecialistFilter({
      ...specialistFilter,
      state: selectedOption?.value || "NY",
    });
  }

  const handelChangeType = (e) => {
    setSpecialistDataLoading(true);
    setSpecialistFilter({
      ...specialistFilter,
      type: e.target.value || "all",
    });
  }
  
  useDocumentTitle("Refer Patient");

  return (
    <>
      <BackBtn href="/outgoing-referral" btnText="Back to outgoing referral" />
      <Spacing lg="0" sm="24" />

      <div className="docpro_page_heading_wrap">
        <h2 className="docpro_page_heading docpro_fs_24">
          <i className="docpro_orange_bg docpro_white_color">
            <Users width={20} height={20} />
          </i>
          Refer Patient
        </h2>
      </div>
      <Spacing lg="4" sm="4" />

      <div className="w-full">
        <div className="docpro_referral">
          <div className="docpro_referral_col_1 w-full">
            <div className="mb-2 bg-white rounded-md">
              <button onClick={() => toggleAccordion(0)}
                className={`w-full flex justify-between items-center accordion-button ${
                  activeIndex === 0 ? 'active' : ''
                }`}
              >
                <span className="text-left docpro_fs_16">Select Patient</span>
                {activeIndex === 0 ? (
                  <ChevronUp width={20} height={20} />
                ) : (
                  <ChevronDown width={20} height={20} />
                )}
              </button>

              <div className={`py-2 ${activeIndex === 0 ? '' : 'hidden'}`}>
                <div className='accordion-button-details'>
                  <div className="docpro_data_table_wrap">
                    <div className="docpro_data_table_headings">
                      <form className="docpro_search_form width_100">
                        <input
                          type="text"
                          placeholder="Search"
                          className="docpro_search_input"
                          onChange={handleChangePatientSearchTerm}
                        />
                        <button className="docpro_search_btn">
                          <Search width={20} height={20} />
                        </button>
                      </form>

                      <div className="docpro_data_table_btns small_filter_btns3 small p-0">
                        {filterData?.length > 0 && (
                          <SaveFilter
                            account_id={account_id}
                            location_id={location_id}
                            user_id={user_id}
                            filterData={filterData}
                            setDataLoading={setPatientDataLoading}
                            setPatientFormData={setPatientFormData}
                            setSelectedInsuranceOptions={setSelectedInsuranceOptions}
                            setFilter={setPatientFilter}
                            setShowSave={setShowSave}
                            loadFilters={loadFilters}
                            reloadData={loadPatientData}
                            reloadDataFilter={defaultPatientFilter}
                            previousScrollPosition={previousScrollPosition}
                            setPreviousScrollPosition={setPreviousScrollPosition}
                          />
                        )}

                        <Filter
                          filterType="patient"
                          reloadData={loadPatientData}
                          reloadDataFilter={patientFilter}
                          setDataLoading={setPatientDataLoading}
                          isFilterCleared={isFilterCleared}
                          onResetFilterStatus={handleResetFilterStatus}
                          selectedInsuranceOptions={selectedInsuranceOptions}
                          setSelectedInsuranceOptions={setSelectedInsuranceOptions}
                          patientFormData={patientFormData}
                          setPatientFormData={setPatientFormData}
                          setShowSave={setShowSave}
                          isEnable={false}
                        />
                      </div>
                    </div>

                    <div className="docpro_filter_summary">
                      <FilterSummary 
                        filter={patientFilter}
                        setFilter={setPatientFilter}
                        loadData={loadPatientData}
                        onClearFilters={handleClearFilters}
                        setSelectedInsuranceOptions={setSelectedInsuranceOptions}
                        clearFilterField={clearFilterField}
                        patientFormData={patientFormData}
                        setPatientFormData={setPatientFormData}
                        setSaveConfirmModal={setSavePatientConfirmModal}
                        showSave={showSave}
                        setShowSave={setShowSave}
                        setPreviousScrollPosition={setPreviousScrollPosition}
                        setDataLoading={setPatientDataLoading}
                      /> 
                    </div>
                    <ReferralPatientDataTable
                      tableData={patientData}
                      dataLoading={patientDataLoading}
                      setCheckPatientData={setCheckPatientData}
                      toggleAccordion={toggleAccordion}
                      referPatientData={referPatientData}
                      setReferPatientData={setReferPatientData}
                    />
                    {patientData.length > 0 && !patientDataLoading && (
                      <DataTablePagination
                        currentPage={patientFilter.page}
                        totalPages={patientDataCount.totalPages}
                        onPageChange={handlePatientPageChange}
                        handleChangeRowsPerPage={handleChangePatientRowsPerPage}
                        totalRecords={patientDataCount.totalCount}
                        currentPageData={patientFilter.per_page}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-2 bg-white rounded-md">
              <button onClick={() => toggleAccordion(1)}
                className={`w-full flex justify-between items-center accordion-button ${
                  activeIndex === 1 && checkPatientData ? 'active' : ''
                }`}
                style={{ pointerEvents: checkPatientData ? 'auto' : 'none' }}
              >
                <span className="text-left docpro_fs_16">Select Specialist</span>
                {activeIndex === 1 && checkPatientData  ? (
                  <ChevronUp width={20} height={20} />
                ) : (
                  <ChevronDown width={20} height={20} />
                )}
              </button>

              <div className={`py-2 ${activeIndex === 1 && checkPatientData ? '' : 'hidden'}`}>
                <div className='accordion-button-details custom-scroll'>
                  <div className="docpro_data_table_wrap">
                    <div className="docpro_data_table_headings">
                      <div className="flex items-center">
                        <form className="docpro_search_form width_100">
                          <input
                            type="text"
                            placeholder="Search"
                            className="docpro_search_input"
                            onChange={handleChangeSpecialistSearchTerm}
                          />
                          <button className="docpro_search_btn">
                            <Search width={20} height={20} />
                          </button>
                        </form>
                      </div>

                      <div className="docpro_data_table_btns p-0">
                        <select
                          className="docpro_form_field"
                          style={{ width: "120px", padding: '5px 27px 5px 12px' }}
                          onChange={handelChangeType}
                          value={specialistFilter.type}
                        >
                          {/* <option value="all">All</option> */}
                          <option value="internal">Internal</option>
                        </select>

                        {/* <Select
                          options={statesData}
                          placeholder="Search..."
                          isSearchable
                          value={statesData.find((option) => option?.value === specialistFilter?.state) || null}
                          onChange={handelChangeState}
                          className="react-select-container"
                          classNamePrefix="react-select"
                          filterOption={(option, rawInput) => {
                            const words = rawInput.toLowerCase().split(" ");
                            return words.every((word) =>
                              option.label.toLowerCase().includes(word)
                            );
                          }}
                          styles={{
                            control: (base) => ({
                              ...base,
                              minHeight: '36px',
                              borderColor: 'var(--border)',
                              borderRadius: '8px',
                              minWidth: '150px'
                            }),
                            dropdownIndicator: (base) => ({
                              ...base,
                              padding: '6px',
                            }),
                            menu: (base) => ({
                              ...base,
                              zIndex: 1050,
                              marginTop: '-2px',
                              borderRadius: '0 0 3px 3px',
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 1050,
                              padding: 0
                            }),
                          }}
                        /> */}

                        {/* <Filter
                          filterType="specialist"
                          reloadData={loadSpecialistData}
                          reloadDataFilter={specialistFilter}
                          setDataLoading={setSpecialistDataLoading}
                          patientFormData={specialistFormData}  // Pass down patientFormData
                          setPatientFormData={setSpecialistFormData}  // Pass down setPatientFormData
                        /> */}
                      </div>
                    </div>

                    <ReferralPracticeDataTable
                      tableData={specialistData}
                      dataLoading={specialistDataLoading}
                      setCheckPracticeData={setCheckPracticeData}
                      toggleAccordion={toggleAccordion}
                      referPatientData={referPatientData}
                      setReferPatientData={setReferPatientData}
                    />
                    {specialistData.length > 0 && !specialistDataLoading && (
                      <DataTablePagination
                        currentPage={specialistFilter.page}
                        totalPages={specialistDataCount.totalPages}
                        onPageChange={handleSpecialistPageChange}
                        handleChangeRowsPerPage={handleChangeSpecialistRowsPerPage}
                        totalRecords={specialistDataCount.totalCount}
                        currentPageData={specialistFilter.per_page}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className='bg-white rounded-md'>
              <button onClick={() => toggleAccordion(2)} 
                className={`w-full flex justify-between items-center accordion-button ${
                  activeIndex === 2 && checkPracticeData ? 'active' : ''
                }`}
                style={{ pointerEvents: checkPracticeData ? 'auto' : 'none' }}
              >
                <span className="text-left docpro_fs_16">Referral Information</span>
                {activeIndex === 2 && checkPracticeData ? (
                  <ChevronUp width={20} height={20} />
                ) : (
                  <ChevronDown width={20} height={20} />
                )}
              </button>

              <div className={`py-2 ${activeIndex === 2 && checkPracticeData ? '' : 'hidden'}`}>
                <div className='accordion-button-details small_padding' style={{ maxHeight: '100%' }}>

                  <form onSubmit={handleReferSubmit}>
                    <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_4">
                      <div className="docpro_grid_item">
                        <label className="docpro_fw_500 docpro_primary_color">
                          Priority <span className="docpro_red_color">*</span>
                        </label>
                        <select className="docpro_form_field size_lg" name='patient_conditon' required onChange={handleReferralChange} >
                          <option value="Normal">Normal</option>
                          <option value="Critical">Critical</option>
                          <option value="Stat">Stat</option>
                        </select>
                      </div>
                      <div className="docpro_grid_item">
                        <label className="docpro_fw_500 docpro_primary_color">
                          DOS <span className="docpro_red_color">*</span>
                        </label>
                        <div className="docpro_input_group">
                          <DatePicker
                            required
                            name="dos"
                            placeholderText="mm/dd/yyyy"
                            className="size_lg"
                            selected={referPatientData.dos}
                            onChange={(date) =>
                              handleChangeReferDate("dos", date)
                            }
                          />
                        </div>
                      </div>
                      <div className="docpro_grid_item">
                        <label className="docpro_fw_500 docpro_primary_color">
                          Referral Date <span className="docpro_red_color">*</span>
                        </label>
                        <div className="docpro_input_group">
                          <DatePicker
                            required
                            name="refer_date"
                            placeholderText="mm/dd/yyyy"
                            className="size_lg"
                            selected={referPatientData.refer_date}
                            onChange={(date) =>
                              handleChangeReferDate("refer_date", date)
                            }
                          />
                        </div>
                      </div>
                      <div className="docpro_grid_item">
                        <label className="docpro_fw_500 docpro_primary_color">
                          End Date <span className="docpro_red_color">*</span>
                        </label>
                        <div className="docpro_input_group">
                          <DatePicker
                            required
                            name="refer_end_date"
                            placeholderText="mm/dd/yyyy"
                            className="size_lg"
                            selected={referPatientData.refer_end_date}
                            onChange={(date) =>
                              handleChangeReferDate("refer_end_date", date)
                            }
                          />
                        </div>
                      </div>
                    </div>

                    <Spacing lg="15" sm="15" />
                    <div>
                      <label className="docpro_fw_500 docpro_primary_color">
                        Referral Reason <span className="docpro_red_color">*</span>
                      </label>
                      <textarea
                        required
                        minLength={2}
                        name="refer_reason"
                        className="docpro_form_field size_lg"
                        cols="30"
                        rows="4"
                        value={referPatientData.refer_reason}
                        onChange={handleReferralChange}
                        placeholder="Referral Reason"
                      ></textarea>
                    </div>

                    <Spacing lg="15" sm="15" />
                    <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                      <div className="docpro_grid_item">
                        <label className="docpro_fw_500 docpro_primary_color">
                          Active Medication List
                        </label>
                        <textarea
                          minLength={2}
                          name="active_medication_list"
                          className="docpro_form_field size_lg"
                          cols="30"
                          rows="4"
                          value={referPatientData.active_medication_list}
                          onChange={handleReferralChange}
                          placeholder="Active Medication List"
                        ></textarea>
                      </div>
                      <div className="docpro_grid_item">
                        <label className="docpro_fw_500 docpro_primary_color">
                          Diagnosis
                        </label>
                        <textarea
                          minLength={2}
                          name="diagnosis"
                          className="docpro_form_field size_lg"
                          cols="30"
                          rows="4"
                          value={referPatientData.diagnosis}
                          onChange={handleReferralChange}
                          placeholder="Diagnosis"
                        ></textarea>
                      </div>
                      
                      <div className="docpro_grid_item">
                        <label className="docpro_fw_500 docpro_primary_color">
                          Attach Medical Summary
                          <button type="button" className="docpro_icon_btn overview pl-2" style={{ width: 'auto', height: 'auto', borderRadius: '50%' }} >
                            <Info width={15} height={15} />
                            <div className="docpro_tip">
                              <span>Max file size {Config?.uploadFileSizeLimit}MB <br /> Accepted file types <br /> {Config?.acceptUploadFileType}</span>
                            </div>
                          </button>
                        </label>
                        <div className='input_file_conatiner'>
                          <label htmlFor="summary-file-upload" className='file_button'>
                            Choose Files
                          </label>
                          <input
                            type="file"
                            id="summary-file-upload"
                            name="attach_medical_summary_files[]"
                            multiple
                            accept={Config?.acceptUploadFileType}
                            className='file_hidden_input'
                            onChange={handleMedicalFileChange}
                          />
                          <span className='file_label'>{selectMedicalFiles?.length === 1 ? `${selectMedicalFiles?.length} File` : selectMedicalFiles?.length > 1 ? `${selectMedicalFiles?.length} Files` : 'No file chosen'}</span>
                        </div>
                        <ul className="mt-1 docpro_mb_0" style={{ listStyle: 'none', paddingLeft: 0 }}>
                          {selectMedicalFiles.map((file, index) => (
                            <li key={index}>
                              <span onClick={() => removeFile(index)} className="docpro_red_color px-1 py-1" style={{ cursor: 'pointer' }}><X height={15} width={15} /></span>
                              <span className="pl-2">{file.name}</span>
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* <div className="docpro_grid_item">
                        <label className="docpro_fw_500 docpro_primary_color">
                          Auth Code
                        </label>
                        <input
                          type="text"
                          placeholder="Auth Code"
                          className="docpro_form_field size_lg"
                          name="refer_auth_code"
                          value={referPatientData.refer_auth_code}
                          onChange={handleReferralChange}
                        />
                      </div> */}
                    </div>

                    <Spacing lg="15" sm="15" />
                    <div className="flex items-center" style={{ justifyContent: 'center' }}>
                      <button
                        type="submit"
                        className="docpro_bordered_btn size_lg docpro_fw_600 docpro_white_color docpro_filed_btn"
                        disabled={submitButtonLoader ? true : false}
                      >
                        <Send width={20} height={20} />
                        <span className="pl-2">Send</span>
                        {submitButtonLoader && (
                          <span className="docpro_loading">
                            <Loader width={20} height={20} />
                          </span>
                        )}
                      </button>
                    </div>
                  </form>

                </div>
              </div>
            </div>
          </div>

          <div className="docpro_referral_col_2 w-full">
            <div className='bg-white rounded-md'>
              <div className="refer_details_heading">
                <h5 className="docpro_mb_0">Selected Patient Information</h5>
              </div>
              <div>
                {checkPatientData !== null ?
                  <ul className="pb-1 mt-1 docpro_mb_0" style={{ listStyle: 'none', paddingLeft: 0 }}>
                    <li className="mx-1 px-3 py-1">
                      <p className='docpro_mb_0 flex items-center'><User width={15} height={15} className="mr-2" /> <span className='mr-2'>First Name :</span> {checkPatientData? checkPatientData?.firstName : ''}</p>
                    </li>
                    <li className="mx-1 px-3 py-1">
                      <p className='docpro_mb_0 flex items-center'><User width={15} height={15} className="mr-2" /> <span className='mr-2'>Last Name :</span> {checkPatientData? checkPatientData?.lastName : ''}</p>
                    </li>
                    <li className="mx-1 px-3 py-1">
                      <p className='docpro_mb_0 flex items-center'><Calendar width={15} height={15} className="mr-2" /> <span className='mr-2'>Date of Birth :</span> {checkPatientData? exchangeDate(checkPatientData?.dob) : ''}</p>
                    </li>
                    <li className="mx-1 px-3 py-1">
                      <p className='docpro_mb_0 flex items-center'><Phone width={15} height={15} className="mr-2" /> <span className='mr-2'>Phone :</span> {checkPatientData? checkPatientData?.mobilePhone : ''}</p>
                    </li>
                    <li className="mx-1 px-3 py-1">
                      <p className='docpro_mb_0 flex items-center'><Infinity width={15} height={15} className="mr-2" /> <span className='mr-2'>Gender :</span> {checkPatientData? checkPatientData?.sex === 'M' ? 'Male' : checkPatientData?.sex === 'F' ? 'Female' : 'Others' : ''}</p>
                    </li>
                    <li className="mx-1 px-3 py-1">
                      <p className='docpro_mb_0 flex items-center'><Star width={15} height={15} className="mr-2" /> <span className='mr-2'>Insurance :</span> {checkPatientData? checkPatientData?.insuranceName : ''}</p>
                    </li>
                    <li className="mx-1 px-3 py-1">
                      <p className='docpro_mb_0 flex items-center'><ShieldCheck width={15} height={15} className="mr-2" /> <span className='mr-2'>Insurance ID :</span> {checkPatientData? checkPatientData?.insuranceID || checkPatientData?.insurance_code : ''}</p>
                    </li>
                  </ul>
                : ''}
              </div>
            </div>

            <Spacing lg="20" sm="20" />
            <div className='bg-white rounded-md'>
              <div className="refer_details_heading relative">
                <h5 className="docpro_mb_0">Selected Specialist Information</h5>

                {checkPracticeData?
                  checkPracticeData?.accept_insurance?.length > 0 ?
                    <div className="specialist_container docpro_cyan_bg docpro_tip_checkbox">
                      <CircleCheck width={20} height={20} style={{ color: 'white' }} />
                      <div className="triangle"></div>
                      <span className="docpro_tip">Practice is registered</span>
                    </div>
                  :
                    <div className="specialist_container docpro_orange_bg docpro_tip_checkbox">
                      <CircleHelp width={20} height={20} style={{ color: 'white' }} />
                      <div className="triangle"></div>
                      <span className="docpro_tip">Practice is not <br /> registered</span>
                    </div>
                :
                  ''
                }
              </div>
              <div>
                {checkPracticeData !== null ?
                  <ul className="pb-1 mt-1 docpro_mb_0" style={{ listStyle: 'none', paddingLeft: 0 }}>
                    <li className="mx-1 px-3 py-1">
                      <p className='docpro_mb_0'><Hospital width={15} height={15} className="mr-1" style={{ marginTop: '-3px' }} /> <span className='mr-1'>Practice Name :</span> {checkPracticeData? checkPracticeData?.provider_organization_name : ''}</p>
                    </li>
                    <li className="mx-1 px-3 py-1">
                      <p className='docpro_mb_0'><Hospital width={15} height={15} className="mr-1" style={{ marginTop: '-3px' }} /> <span className='mr-1'>Authorized :</span> {checkPracticeData? checkPracticeData?.authorized_official_first_name+' '+checkPracticeData?.authorized_official_middle_name+' '+checkPracticeData?.authorized_official_last_name+' ('+checkPracticeData?.authorized_official_title_or_position+')' : ''}</p>
                    </li>
                    <li className="mx-1 px-3 py-1">
                      <p className='docpro_mb_0'><MapPin width={15} height={15} className="mr-1" style={{ marginTop: '-3px' }} /> <span className='mr-1'>Address :</span> {checkPracticeData? checkPracticeData?.provider_first_line_business_practice_location_address+', '+checkPracticeData?.provider_business_practice_location_address_city_name : ''}</p>
                    </li>
                    <li className="mx-1 px-3 py-1">
                      <p className='docpro_mb_0 flex items-center'><Phone width={15} height={15} className="mr-2" /> <span className='mr-2'>Phone :</span> {checkPracticeData? usPhoneFormat(checkPracticeData?.provider_business_practice_location_address_telephone_number) : ''}</p>
                    </li>
                    {(checkPracticeData && checkPracticeData?.provider_business_practice_location_address_fax_number) && (
                      <li className="mx-1 px-3 py-1">
                        <p className='docpro_mb_0 flex items-center'><Printer width={15} height={15} className="mr-2" /> <span className='mr-2'>Fax :</span> {checkPracticeData? usPhoneFormat(checkPracticeData?.provider_business_practice_location_address_fax_number) : ''}</p>
                      </li>
                    )}
                    <li className="mx-1 px-3 py-1">
                      <p className='docpro_mb_0 flex items-center'><MapPinned width={15} height={15} className="mr-2" /> <span className='mr-2'>Zip Code :</span> {checkPracticeData? checkPracticeData?.provider_business_practice_location_address_postal_code?.slice(0, 6) : ''}</p>
                    </li>
                    <li className="mx-1 px-3 py-1">
                      <p className='docpro_mb_0 flex items-center'><UserRoundCog width={15} height={15} className="mr-2" /> <span className='mr-2'>State :</span> {checkPracticeData? checkPracticeData?.provider_business_practice_location_address_state_name : ''}</p>
                    </li>
                    {(checkPracticeData && (checkPracticeData?.accept_insurance?.length > 0)) && (
                      <li className="mx-1 px-3 py-1">
                        <p className='docpro_mb_0 flex items-center'><Star width={15} height={15} className="mr-2" /> <span className='mr-2'>Accepted Insurance :</span> 
                          {checkPracticeData?
                            checkPracticeData?.accept_insurance?.length > 0 ?
                              <span onClick={() => handleViewInsurances(checkPracticeData?.accept_insurance)}>
                                <Badge color="blue" square variant="docpro_fs_12 pointer">
                                  View
                                </Badge>
                              </span>
                            :
                              <span className="flex items-center justify-between">
                                <span className="docpro_red_color mr-2" style={{ paddingRight: '10px' }}>No Insurance Found</span>

                                {/* <span onClick={() => setViewInvitationModal(true)}>
                                  <Badge color="blue" square variant="docpro_fs_12 pointer">
                                    Invite to join
                                  </Badge>
                                </span> */}
                              </span>
                          :
                            ''
                          }
                        </p>
                      </li>
                    )}
                    <li className="mx-1 px-3 py-1">
                      <p className='docpro_mb_0'><ShieldCheck width={15} height={15} className="mr-1" style={{ marginTop: '-3px' }} /> <span className='mr-1'>Speciality :</span> 
                        { checkPracticeData? 
                          checkPracticeData?.specialities?.length > 0 ?
                            checkPracticeData?.specialities?.map((element, index) => (
                              element?.id === referPatientData?.refer_to_specialty_id && (
                                <Badge key={index} color="cyan" variant="docpro_fs_12">
                                  {element.name}
                                </Badge>
                              )
                            ))
                          :
                            <span className="docpro_red_color">No Specialty found</span>
                        : ''}
                      </p>
                    </li>
                  </ul>
                : ''}
              </div>
            </div>
          </div>
        </div>
      </div>

      {viewInsurances && (
        <InsuranceViewModal 
          acceptInsuranceData={acceptInsuranceData}
          viewInsurances={viewInsurances}
          setViewInsurances={setViewInsurances}
        />
      )}
      {viewInvitationModal && (
        <InviteSpecialistModal
          viewInvitationModal={viewInvitationModal}
          setViewInvitationModal={setViewInvitationModal}
          account_id={account_id}
          location_id={location_id}
        />
      )}

      {savePatientConfirmModal && (
        <FilterSaveConfirmationModal
          account_id={account_id}
          location_id={location_id}
          user_id={user_id}
          filter_type="patient-database"
          filter={patientFilter}
          openModal={savePatientConfirmModal}
          setOpenModal={setSavePatientConfirmModal}
          setShowSave={setShowSave}
          loadFilters={loadFilters}
          previousScrollPosition={previousScrollPosition}
        />
      )}
    </>
  );
}
